// extracted by mini-css-extract-plugin
module.exports = {"iconList":"IconsPage_iconList__3rjqt"};